import axios from "axios"
import { GetProfileService } from "../auth/getprofile";

export async function EnrollCourseService(course_id, user_id) {
    let msg = "Invalid Crediationals";
    const headers = {
        'Content-Type': 'application/json'
    };
    const formData = {
        course_id: course_id,
        user_id: user_id
    }
    const res = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/courses/enroll`, formData, { headers });
    console.log(res);
    if (res.data.error) {
        console.log(res.data);
        msg = res.data.error;
    } else {
        msg = res.data.message;
    }
    return msg;
}


export const EnrollCoursePaymentService = async(amount, course_id, user_id, dispatch) => {
    let msg = "";
    console.log(amount)
    var options = {
        "key": process.env.REACT_APP_RAZORPAY_ID_KEY,
        "amount": amount, // 2000 paise = INR 20, amount in paisa
        "name": "",
        "description": "",
        'order_id': "",
        "handler": async function(response) {
            console.log(response);
            var values = {
                razorpay_signature: response.razorpay_signature,
                razorpay_order_id: response.razorpay_order_id,
                amount: amount,
                razorpay_payment_id: response.razorpay_payment_id,
                courseId: course_id,
                studentId: user_id,
            }

            await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/courses/payment-verification`, values)
                .then(res => {
                    console.log(res);
                    if (res.data.error) {
                        console.log(res.data);
                        msg = res.data;
                    } else {
                        GetProfileService(user_id, dispatch);
                        alert(JSON.stringify(res.data, null, 2));
                        window.location.replace(`/dashboard/courses/${course_id}`)
                        msg = res.data;
                    }
                    return msg;
                })
                .catch(e => { msg = "Some Error while varification."; return msg })
        },
        "prefill": {
            "name": 'Sanjana Kumari',
            "email": 'sanjana@gmail.com',
            "contact": '1234567890',
        },
        "notes": {
            "address": "Hello World"
        },
        "theme": {
            "color": "#528ff0"
        }
    };
    await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/courses/checkout`, { courseId: course_id, amount: amount })
        .then(res => {
            options.order_id = res.data.order.id;
            options.amount = res.data.order.amount;
            console.log(options)
            var rzp1 = new window.Razorpay(options);
            rzp1.open();
        })
        .catch(e => console.log(e))
}